import {
    STORAGE_BUCKETS,
    IMAGE_BREAKPOINTS,
    IMAGE_MIME_TYPE
} from "../../constants/arvanBuckets";

interface ResponsiveImageProps {
    alt?: string;
    src?: string;
    desktop?: string;
    tablet?: string;
    mobile?: string;
    className?: string; // Applied to the <img>, which is what is actually drawn
    isPublic?: boolean;
    priority?: boolean; // Above-the-fold images load immediately instead of lazily
}

// Absolute URLs pass through; storage paths are prefixed with the bucket
const getImageUrl = (bucket: string, image?: string): string => {
    if (!image) return "";

    if (image.startsWith("http://") || image.startsWith("https://")) return image;

    return `${bucket}/${image.replace(/^\/+/, "")}`;
};

const ResponsiveImage = ({
                             alt = "",
                             src,
                             desktop,
                             tablet,
                             mobile,
                             className,
                             isPublic = true,
                             priority = false
                         }: ResponsiveImageProps) => {
    const bucket = isPublic ? STORAGE_BUCKETS.PUBLIC : STORAGE_BUCKETS.PRIVATE;
    const fallbackUrl = getImageUrl(bucket, src);

    // An empty src makes the browser request the page itself and show a broken image
    if (!fallbackUrl) return null;

    // Same three sources as before, described as data instead of three copies of JSX
    const sources = [
        { media: IMAGE_BREAKPOINTS.DESKTOP, image: desktop },
        { media: IMAGE_BREAKPOINTS.TABLET, image: tablet },
        { media: IMAGE_BREAKPOINTS.MOBILE, image: mobile }
    ];

    return (
        <picture>
            {sources.map(
                ({ media, image }) =>
                    image && (
                        <source
                            key={media}
                            type={IMAGE_MIME_TYPE}
                            media={media}
                            srcSet={getImageUrl(bucket, image)}
                        />
                    )
            )}

            <img
                src={fallbackUrl}
                alt={alt}
                loading={priority ? "eager" : "lazy"}
                className={className}
            />
        </picture>
    );
};

export default ResponsiveImage;